<template>
  <div>
    <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
    <title-bar :title-stack="titleStack" />

    <div class="card">
      <card-header
        :title="pageTitle"
        :route="`/adicionarVeiculo?${$util.formatQueryUrl($route.query)}`"
      />

      <filter-veiculos
        @filtrar="handleFilter"
        @limpar-filtros="handleLimparFiltros"
      />

      <section class="section is-main-section">
        <card-component class="has-table has-mobile-sort-spaced">
          <!-- Modals -->
          <modal-delete-veiculo
            :is-active="isModalDeleteActive"
            :item="veiculoSelecionado"
            @confirm="handleModalClose"
            @cancel="handleModalClose"
          />

          <!-- Tabela -->
          <b-table
            :checked-rows.sync="checkedRows"
            :data="processedVeiculos"
            striped
            hoverable
          >
            <b-table-column v-slot="props" label="Placa" field="placa" sortable>
              {{ props.row.placa }}
            </b-table-column>

            <b-table-column v-slot="props" label="Marca" field="marca" sortable>
              {{ props.row.marca }}
            </b-table-column>

            <b-table-column
              v-slot="props"
              label="Modelo"
              field="modelo"
              sortable
            >
              {{ props.row.modelo }}
            </b-table-column>

            <b-table-column
              v-slot="props"
              label="Ações"
              cell-class="is-actions-cell"
              centered
            >
              <action-buttons
                :item="props.row"
                :to-config="{
                  name: 'FormVeiculo.edit',
                  params: { id: props.row.id },
                  query: { area: $route.query.area },
                }"
                @status-change="
                  (state) => atualizarStatus(state.item, state.status)
                "
                @delete="(veiculo) => openModalDelete(veiculo)"
              />
            </b-table-column>

            <template #empty>
              <empty-state />
            </template>
          </b-table>

          <!-- Paginação -->
          <pagination-section
            :current-page="pageable.current"
            :total-items="totalElements"
            :per-page="15"
            :current-query="$route.query"
            @page-change="handlePageChange"
          />
        </card-component>
      </section>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import VeiculoService from "@/services/VeiculoService.js";
import storage from "@/mixins/storage";

// Componentes
import TitleBar from "@/components/TitleBar.vue";
import CardComponent from "@/components/Cards/CardComponent.vue";
import ModalDeleteVeiculo from "@/components/Modals/ModalDeleteVeiculo.vue";
import ModalDesligamento from "@/components/Modals/ModalDesligamento.vue";
import FilterVeiculos from "@/components/Filters/FilterVeiculos.vue";
import CardHeader from "@/components/Cards/CardHeader.vue";
import StatusTag from "@/components/StatusTag.vue";
import ActionButtons from "@/components/ActionButtons.vue";
import EmptyState from "@/components/EmptyState.vue";
import PaginationSection from "@/components/PaginationSection.vue";

export default defineComponent({
  name: "ListVeiculo",
  components: {
    TitleBar,
    CardComponent,
    ModalDeleteVeiculo,
    FilterVeiculos,
    CardHeader,
    StatusTag,
    ActionButtons,
    EmptyState,
    PaginationSection,
    ModalDesligamento
  },
  mixins: [storage],
  data() {
    return {
      titleStack: ["SECAPI", "Veículos", "Listar Veículos"],
      veiculos: [],
      pageable: {
        current: 1,
        size: 0,
      },
      totalElements: 0,
      isModalDesligarActive: false,
      isModalDeleteActive: false,
      veiculoSelecionado: null,
      checkedRows: [],
      isLoading: false,
    };
  },
  computed: {
    processedVeiculos() {
      return this.veiculos.map((veiculo) => ({
        id: veiculo.id,
        placa: veiculo.placa,
        empresa: veiculo.empresa?.razaoSocial,
        marca: veiculo.marca,
        modelo: veiculo.modelo,
        ano: veiculo.anoFabricacao,
      }));
    },
    pageTitle() {
      if(this.$route.query.tipo === "AVULSO"){
        return "AVULSO"
      }else{
        return "GERAL"
      }
    },
    currentRoute() {
      return this.$route;
    },
  },
  watch: {
    "$route.query": {
      immediate: true,
      async handler(query) {
        this.pageable.current = parseInt(query.page) || 1;
        await this.fetchData();
      },
    },
  },
  methods: {
    async fetchData() {
      try {
        const response = await VeiculoService.getVeiculos(
          this.pageable.current - 1,
          this.$util.formatQueryUrl(this.currentRoute.query)
        );
        this.veiculos = response.data.content;
        this.totalElements = response.data.totalElements;
        this.pageable.size = response.data.totalElements;
      } catch (error) {
        this.handleError(error, "Erro ao carregar veículos");
      }
    },
    handlePageChange(newPage) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: newPage,
        },
      });
    },
    handleFilter(filtro) {
      const newQuery = {
        ...this.currentRoute.query,
        ...filtro,
        page: 1,
      };
      this.$router.push({ query: newQuery });
    },
    handleLimparFiltros() {
      this.$router.replace({
        query: {
          area: this.$route.query.area,
        },
      });
    },
    openModalDelete(veiculo) {
      this.veiculoSelecionado = veiculo; // Define o veículo selecionado
      this.isModalDeleteActive = true; // Abre o modal
    },

    async handleModalClose() {
      this.isModalDesligarActive  = false; // Fecha o modal de desligamento
      this.isModalDeleteActive = false; // Fecha o modal de delete
      this.veiculoSelecionado = null; // Limpa o veículo selecionado
      await this.fetchData(); // Recarrega os dados após a exclusão
    },

    handleError(error, message) {
      this.$buefy.toast.open({
        message: message,
        type: "is-danger",
        position: "is-bottom",
      });
      console.error(error);
    },
  },
});
</script>
